var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotinterestedunibox = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 5L2.55841 7.92991C2.3404 8.19151 2.2314 8.32232 2.22974 8.43279C2.22829 8.52882 2.27108 8.62019 2.34579 8.68056C2.43172 8.75 2.60199 8.75 2.94252 8.75H7.5L6.875 13.75L10 10M9.78127 6.25H12.0575C12.398 6.25 12.5683 6.25 12.6542 6.31944C12.7289 6.37981 12.7717 6.47118 12.7703 6.56721C12.7686 6.67768 12.6596 6.80849 12.4416 7.07009L11.5939 8.08732M6.60797 3.07041L8.12498 1.25L7.75015 4.24857M13.125 13.125L1.875 1.875",
  stroke: "#535862",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotinterestedunibox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notinterestedunibox.577ef8f254c7cf04a0196d8e6f51dac6.svg";